/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

//calendar --------------------------------------------
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
// -----------------------------------------------

//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import TreatmentFilterPopup from "./Popup/TreatmentFilterPopup";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { replaceListByIds, updateListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import TreatmentListHeader from "./Header/TreatmentListHeader";
import SaveTreatment from "./Popup/SaveTreatment"
import ViewTreatment from "./Popup/ViewTreatment"

// Add treatment status options and helper function
const treatmentStatusOptions = [
  { label: "Planned", value: "planned" },
  { label: "Ongoing", value: "ongoing" },
  { label: "Completed", value: "completed" },
  { label: "Paused", value: "paused" },
  { label: "Cancelled", value: "cancelled" },
];

// Helper function to map single value to option object
const mapValuesToSingleOption = (savedValue, optionsList) => {
  if (!savedValue) return null;
  
  const foundOption = optionsList.find(option => option.value === savedValue);
  return foundOption || { value: savedValue, label: savedValue }; // fallback if not found in options
};

const TreatmentsListBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  const moduleSlug = "MOD_PROJECT";

  const localizer = momentLocalizer(moment);
  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [tagList, setTagList] = useState([]);
  const [treatmentList, setTreatmentList] = useState([]);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedTreatmentIds, setSelectedTreatmentIds] = useState([]);
  const [selectedTreatmentId, setSelectedTreatmentId] = useState(null);
  const [selectedViewTreatmentId, setSelectedViewTreatmentId] = useState(null);

  const [filterDates, setfilterDates] = useState("");
  const [filterName, setfilterName] = useState("");
  const [filterSlug, setfilterSlug] = useState("");
  const [filterSubject, setfilterSubject] = useState("");
  const [filterLabels, setfilterLabels] = useState([]);

  const [isReload, setIsReload] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Event style getter for calendar
  const eventStyleGetter = (event) => {
    const status = event.status;
    let backgroundColor = "#3174ad"; // default blue
    
    switch (status) {
      case "completed":
        backgroundColor = "#28a745"; // green
        break;
      case "ongoing":
        backgroundColor = "#007bff"; // blue
        break;
      case "planned":
        backgroundColor = "#17a2b8"; // cyan
        break;
      case "paused":
        backgroundColor = "#ffc107"; // yellow
        break;
      case "cancelled":
        backgroundColor = "#dc3545"; // red
        break;
      default:
        backgroundColor = "#6c757d"; // gray
    }
    
    return {
      style: {
        backgroundColor,
        borderRadius: "3px",
        opacity: 0.8,
        color: "white",
        border: "0px",
        display: "block"
      }
    };
  };

  // Convert treatment data to calendar events
  const convertTreatmentsToEvents = (treatments) => {
    return treatments.map((treatment) => {
      const startDate = treatment.startdate ? new Date(treatment.startdate) : new Date();
      // end date should be same as start date for all day event
      const endDate = treatment.startdate ? new Date(treatment.startdate) : new Date();

      //const endDate = treatment.enddate ? new Date(treatment.enddate) : new Date(startDate.getTime() + 60 * 60 * 1000); // 1 hour default
      
      return {
        id: treatment._id,
        title: treatment.title,
        start: startDate,
        end: endDate,
        status: treatment.medicalextension?.treatmentstatus || "planned",
        resource: treatment, // Store the full treatment data
        doctor: treatment.medicalextension?.doctor?.name || "Not Assigned",
        patient: treatment.medicalextension?.patient?.name || "Not Assigned",
        speciality: treatment.projecttypeid?.name || "General"
      };
    });
  };

  const getAllTreatments = async () => {
    setSelectedTreatmentIds([]);
    setIsLoading(true);

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_TREATMENTS +
        `?token=${token}&modulename=treatment`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("Treatment Request URL:", requestUrl); // Debugging line to check the final request URL

      const response = await getData(requestUrl);

      console.log("Treatment Response Data:", response); // Debugging line to check the response data

      setIsLoading(false);

      if (response.status) {
        setTreatmentList(response.data);
        setCalendarEvents(convertTreatmentsToEvents(response.data));

        setShowAlert(true);
        setAlertMessage('Treatments fetched successfully');
        setMessageType("success");
      } 

    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for change status
  const changeStatusHandler = async () => {

  };

  //function for reset filter
  const resetFilterData = () => {
    setIsFilterReset(true);
    setJsonFilterQuery([]);
    setIsReload(true);
  };

  // Handle calendar event selection
  const onSelectCalendarEvent = (event) => {
    setSelectedViewTreatmentId(event.id);
    // Open the ViewTreatment offcanvas
    const offcanvas = new bootstrap.Offcanvas(document.querySelector("#viewTreatmentOffCanvas"));
    offcanvas.show();
  };

  useEffect(() => {
    if (isReload) {
      getAllTreatments();
      setIsReload(false);
    }
  }, [isReload]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllTreatments();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    getAllTreatments();
  }, []);

  // Update calendar events when treatment list changes
  useEffect(() => {
    setCalendarEvents(convertTreatmentsToEvents(treatmentList));
  }, [treatmentList]);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_LEAD"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Treatment")}
          />
          <div className="container-fluid px-lg-5">
            <TreatmentListHeader
              reloadTreatments={resetFilterData}
              changeStatusHandler={changeStatusHandler}
            />
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="calendar-wrapper">
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="d-flex flex-wrap gap-2 align-items-center">
                      <span className="fw-semibold me-2">Legend:</span>
                      <span className="badge" style={{backgroundColor: "#28a745"}}>Completed</span>
                      <span className="badge" style={{backgroundColor: "#007bff"}}>Ongoing</span>
                      <span className="badge" style={{backgroundColor: "#17a2b8"}}>Planned</span>
                      <span className="badge" style={{backgroundColor: "#ffc107", color: "#000"}}>Paused</span>
                      <span className="badge" style={{backgroundColor: "#dc3545"}}>Cancelled</span>
                      <span className="badge" style={{backgroundColor: "#6c757d"}}>Unknown</span>
                    </div>
                  </div>
                </div>
                <div style={{ height: "70vh", position: "relative" }}>
                  <Calendar
                    localizer={localizer}
                    events={calendarEvents}
                    startAccessor="start"
                    endAccessor="end"
                    titleAccessor="title"
                    onSelectEvent={onSelectCalendarEvent}
                    eventPropGetter={eventStyleGetter}
                    style={{ height: "100%" }}
                    views={['month', 'week', 'day', 'agenda']}
                    defaultView="month"
                    popup
                    tooltipAccessor={(event) => 
                      `${event.title}\nDoctor: ${event.doctor}\nPatient: ${event.patient}\nStatus: ${event.status}`
                    }
                  />
                </div>
              </div>
            )}
          </div>

          {/* ==== modals and popup section === */}
          {/* --- filter popup --- */}
          <TreatmentFilterPopup
            jsonFilterQuery={jsonFilterQuery}
            setJsonFilterQuery={setJsonFilterQuery}
            moduleSlug={moduleSlug}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
          />

          <AddLabelModal
            moduleName="treatment"
            selectedIds={selectedTreatmentIds}
            afterTagModalClose={() => {
              setTimeout(() => {
                getAllTreatments();
              }, 2200);
            }}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <SaveTreatment
            selectedTreatmentId={selectedTreatmentId}
            setSelectedTreatmentId={setSelectedTreatmentId}
            afterActionClose={getAllTreatments}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <ViewTreatment
            selectedTreatmentId={selectedViewTreatmentId}
            setSelectedTreatmentId={setSelectedViewTreatmentId}
            afterActionClose={getAllTreatments}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default TreatmentsListBody;
